var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#6e7d94;}.b{clip-path:url(#a);}.c{fill:none;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 84,
    height: 84,
    transform: "translate(592 4875)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(-592 -4875)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(592 4875)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,0H84V84H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M71.33,29.995l-4.3,6.475A28,28,0,0,1,66.255,63H17.745A28,28,0,0,1,54.53,23.975l6.475-4.305A35,35,0,0,0,11.725,66.5a7,7,0,0,0,6.02,3.5H66.22a7,7,0,0,0,6.09-3.5,35,35,0,0,0-.945-36.54ZM37.065,53.935a7,7,0,0,0,9.9,0L66.78,24.22,37.065,44.03a7,7,0,0,0,0,9.9Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeed);
export default __webpack_public_path__ + "static/media/speed.350af2c85275a8a3d645ea50211d4ef9.svg";
export { ForwardRef as ReactComponent };